// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"0a95ae90","977":"7e9ae714"}[chunkId] + ".chunk.js";
};